import React from "react";
import "./MakerGarage.css";
import printer_3d from "../imgs/printer_3d.png";
import arduino from "../imgs/arduino.png";
import ti_launchpad from "../imgs/ti_launchpad.png";
import raspberry_pi from "../imgs/raspberry_pi.png";
import Microsoft_logo from "../imgs/Microsoft_logo.png";
import ECE_logo from "../imgs/ECE_logo.png";

const MakerGarage = () => {
  return (
    <div className="home">
      <div className="blackText">
      <div className="navbarSpace"></div>
        <h2>Maker Garage</h2>
        <h3>New office at Malachowsky Hall 2100G</h3>
        <div className="makerDescription">
          The WECE Maker Garage is a collaborative environment for hackers and
          makers to utilize state of the art equipment such as 3D printers,
          Arduinos, TI Launchpads, Raspberry PI Picos, and much more. The Maker
          Garage gives engineers and developers the ability to join forces on
          ideas and skills to turn engineering dreams into reality. Our space
          allows for fast paced prototyping and encourages early failures in
          design and development to ensure the most robust end products. The
          Maker Garage is open to everyone during certain hours. Please be sure
          to ask in Slack about the availability before stopping by! We hope to
          see you soon.
        </div>
        <h3>Equipment</h3>
      </div>
      {/* Adds a card for each piece of equipment */}
      <div class="cards-container">
          <div class="card">
            <img className="printer_3d" src={printer_3d} alt="3d Printer" />
            <span className="makerGarageText">3D Printers</span>
          </div>
          <div class="card">
            <img className="arduino" src={arduino} alt="Arduino" />
            <span className="makerGarageText">Arduinos</span>
          </div>
          <div class="card">
            <img
              className="ti_launchpad"
              src={ti_launchpad}
              alt="TI Launchpad"
            />
            <span className="makerGarageText">TI Launchpads</span>
          </div>
          <div class="card">
            <img
              className="raspberry_pi"
              src={raspberry_pi}
              alt="Raspberry PI"
            />
            <span className="makerGarageText">Raspberry Pis</span>
          </div>
          {/* Add more cards as needed --> */}
        </div>
        <div className="blackText">
          <h2>Maker Space Sponsors</h2>
        </div>
        <div class="cards-container">
          <div class="card">
            <img
              className="Microsoft_logo"
              src={Microsoft_logo}
              alt="Microsoft Logo"
            />
          </div>
          <div class="card">
            <img className="ECE_logo" src={ECE_logo} alt="ECE Logo" />
          </div>
        </div>
    </div>
  );
};

export default MakerGarage;
